import React from 'react';
import { Accordion, AccordionItem } from '../../ui/Accordion';
export function FAQ() {
  return (
    <Accordion className="mx-5">
      <AccordionItem heading="How is XPayroll's Group health insurance better than other market offerings?">
        <li className="">
          Group health insurance is structured as a group cover. Under Group health insurance, you
          get the following benefit:
        </li>
        <br />
        <ol className="list-decimal ml-4">
          <li className="">
            Affordable: The premium payable will be lower than retail health insurance since the
            underwriter is pricing the risk for a large group of individuals. There is no broker or
            agent involved and this enables you to save further on commissions that wold otherwise
            be payable.
          </li>
          <li className="">
            Comprehensive yet customised: The solution is tailor-made for XPayroll clients and our
            client demographics enabled us to craft a well-priced health cover with ICICI Lombard
          </li>
          <li className="">
            Convenient: No documentation and medical check-up requirement and instant policy
            enrolment mean that you can enrol in minutes.
          </li>
          <li className="">
            XPayroll (Razorpay) is the master policyholder and, we've worked with our Insurer, ICICI
            Lombard to bring the same transparency, convenience, simplicity, and affordability that
            you have experienced with XPayroll and Razorpay products so far
          </li>
        </ol>
      </AccordionItem>
      <AccordionItem heading="What is the Waiting Period for the 3 plans?">
        Zero-day on injuries & accidents and 30 days on all other treatments. The 30 day waiting
        period is waived off in the Essential and Premium Plans.
      </AccordionItem>
      <AccordionItem heading="Do I need to buy Group insurance for my employees?">
        On April 15th 2020, the Government of India, as part of order №40–3/2020-DM-I (A), issued as
        part of the consolidated revised guidelines by the ministry of home affairs, made it
        mandatory for all employers, who resume functioning post-COVID-19 lockdown in the country,
        to provide medical insurance to their employees. Not just that, insurance protection is the
        most preferred benefit by employees. That’s because it takes the challenge of finding the
        right policy, helps them in managing healthcare costs and ensures that they get easy claims.
        So, when you provide health insurance, your employees feel cared for.
      </AccordionItem>
      <AccordionItem heading="Is there any minimum requirement to take group insurance?">
        With XPayroll, we’ve worked with the Insurers to remove the minimum cap of 20 employees to
        purchase Group Health Insurance and have extended this benefit to organizations as small as
        2 employees. The Standard and Premium plan has a minimum cap of 5 employees.
      </AccordionItem>
      <AccordionItem heading="Can we opt to cover family members?">
        <p>Yes, you have three policy design options:</p>
        <ol className="list-decimal mt-1 ml-6">
          <li>E plan: Covers employees only</li>
          <li>ESC plan: Covers employees, spouse, and upto 4 dependent children</li>
          <li>
            ESCP plan: Covers employees, spouse, upto 4 dependent children, and 2 parents/in-laws
            Other relatives, like siblings or uncles, cannot be covered.
          </li>
        </ol>
      </AccordionItem>
      <AccordionItem heading="Can I take policy for specific employees?">
        No, group covers don't allow any selection. You will have to cover ALL your employees who
        are present within XPayroll with no exception. Read more on why selection is not allowed.
      </AccordionItem>
      <AccordionItem heading="Can I take policy for specific family members?">
        No, group cover doesn't allow any selection. If you choose to take the ESC-plan, you will
        have to cover spouses of all married employees and all dependent children. If you choose to
        take the ESCP-plan, you will have to cover spouses of all married employees, all dependent
        children, and parents of all employees.
      </AccordionItem>
      <AccordionItem heading="Can I add members after the initial setup?">
        Yes, you can add new employees, add new dependents (at the time of marriage or childbirth).
        Additions are done automatically whenever you add an employee on XPayroll For additions, you
        would get charged based on a 1-year basis for employees. E.g., if the annual premium for a
        35-yr old member is ₹2000, and you add a member 6 months later, you would pay ₹2000 for that
        member.
      </AccordionItem>
      <AccordionItem heading="What if an employee leaves the organization after I’ve purchased Insurance?">
        When an employee leaves the organization, you get a pro-rated refund basis the time
        remaining in the 1-year policy period. For eg. if the annual premium for a 30-yr old member
        is Rs. 2000, and if they leave after 6 months, then you get refunded Rs. 1000 .Note - In
        case there are insurance claims made by the member there are no refunds.
      </AccordionItem>
      <AccordionItem heading="What is the timeline for the refund to come?">
        The checking of whether a claim is made is dependent on the Insurance partner, a refund can take
        upto 5 to 6 weeks. The refund amount will be added back to your XPayroll account and you will see
        an entry in the Ledger for this.
      </AccordionItem>
      <AccordionItem heading="How do claims works?">
        Your team members and employees would get access to our partner, Plum’s app to understand
        their insurance cover, see what's covered and what's not covered. They can see cashless
        hospitals nearby. They would also see the step by step claims process on the app itself. The
        insurance covers both cashless claims and reimbursement claims.
      </AccordionItem>
    </Accordion>
  );
}
